module.exports = __webpack_public_path__ + "img/background_18.27b8f366.jpg";